import { REGEX_EXPS } from "utils/constants";
import { normalizeTextField } from "utils/helpers/validations";
import * as yup from "yup";

const validation = (messages) => {
  const requiredName = yup
    .string()
    .transform(normalizeTextField)
    .typeError(messages.REQUIRED)
    .matches(REGEX_EXPS.name, messages.INVALID_NAME)
    .required(messages.REQUIRED);
  return yup.object().shape({
    members: yup.array().of(
      yup.object().shape({
        firstName: requiredName,
        lastName: requiredName,
        birthDate: yup.date().nullable().required(messages.REQUIRED),
        relationship: yup.string().nullable().required(messages.REQUIRED),
      }),
    ),
  });
};

export default validation;
